<section *ngIf="pageData" class="form-wrapper">
  <div class="form-with-cover">
    <div class="form-container">
      <div class="form-title-container">
        <ng-container *ngIf="mode() === 'email'">
          <h1>{{ pageData?.title }}</h1>
          <p>{{ pageData.sub_title }}</p>
        </ng-container>
        <ng-container *ngIf="mode() === 'social'">
          <h1>
            {{ pageData.social_title }}{{ auth.socialUser?.firstName }}
          </h1>
          <p>{{ pageData.social_sub_title }}</p>
        </ng-container>
      </div>

      <ng-template #showLoader>
        <div class="spinner"></div>
      </ng-template>
      <form
        *ngIf="
          registerForm && !(loadingUni() || loadingAccommodation());
          else showLoader
        "
        id="register-form"
        class="register-form"
        [class.social-register-form]="mode() === 'social'"
        [formGroup]="registerForm"
        (ngSubmit)="register($event)"
        (keydown.enter)="$event.preventDefault()"
      >
        <input
          type="hidden"
          name="referrer"
          id="referrer"
          formControlName="referrer"
        />

        <input
          type="hidden"
          name="university_id"
          name="university_id"
          value=""
        />
        <input type="hidden" name="residence_id" name="residence_id" value="" />

        <div class="form-row">
          <div class="form-field">
            <div class="label-container">
              <label for="first_name">{{ pageData.first_name }}</label>
              <app-tooltip
                *ngIf="pageData.first_name_tooltip"
                id="first_name_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>
            <input
              formControlName="first_name"
              type="text"
              name="first_name"
              id="first_name"
              [class.error]="
                (submitted() || formControl['first_name'].dirty) &&
                formControl['first_name'].errors
              "
            />
            <span
              class="error"
              *ngIf="
                (submitted() || formControl['first_name'].dirty) &&
                formControl['first_name'].errors
              "
            >
              {{ pageData.first_name_error }}
            </span>
          </div>
          <div class="form-field">
            <div class="label-container">
              <label for="surname">{{ pageData.surname }}</label>
              <app-tooltip
                *ngIf="pageData.surname_tooltip"
                id="surname_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>
            <input
              formControlName="surname"
              type="text"
              name="surname"
              id="surname"
              [class.error]="
                (submitted() || formControl['surname'].dirty) &&
                formControl['surname'].errors
              "
            />
            <span
              class="error"
              *ngIf="
                (submitted() || formControl['surname'].dirty) &&
                formControl['surname'].errors
              "
            >
              {{ pageData.surname_error }}
            </span>
          </div>
        </div>

        <ng-container *ngIf="mode() === 'email'">
          <div class="form-row">
            <div class="form-field">
              <div class="label-container">
                <label for="email">{{ pageData.email_address }}</label>
                <app-tooltip
                  *ngIf="pageData.email_address_tooltip"
                  id="email_address_tooltip"
                  (tooltipClicked)="openTooltip($event)"
                ></app-tooltip>
              </div>
              <input
                formControlName="email"
                type="text"
                name="email"
                id="email"
                [class.error]="
                  (submitted() || formControl['email'].dirty) &&
                  formControl['email'].errors
                "
              />
              <span
                class="error"
                *ngIf="
                  (submitted() || formControl['email'].dirty) &&
                  formControl['email'].errors
                "
              >
                <ng-container
                  *ngIf="
                    formControl['email'].errors['required'];
                    else emailInvalidError
                  "
                >
                  {{ pageData.email_address_empty_error }}
                </ng-container>
                <ng-template #emailInvalidError>
                  {{ pageData.email_address_invalid_error }}
                </ng-template>
              </span>
            </div>
          </div>
        </ng-container>

        <input
          type="hidden"
          name="university_id"
          id="university_id"
          formControlName="university_id"
        />

        <div class="form-row" *ngIf="!isUnihomeDeeplink()">
          <div class="form-field">
            <div class="label-container">
              <label for="university_name">{{ universityInputText() }}</label>
              <app-tooltip
                *ngIf="
                  pageData.university_name_tooltip ||
                  pageData.staying_tooltip_unihomes
                "
                [id]="universityInputTooltipId()"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>
            <div class="lookup-wrapper">
              <input
                [readOnly]="isUnihomeDeeplink()"
                class="modal-lookup"
                formControlName="university_name"
                type="text"
                name="university_name"
                id="university_name"
                [class.error]="
                  (submitted() || formControl['university_name'].dirty) &&
                  formControl['university_id'].errors
                "
                [class.grayout]="isUnihomeDeeplink()"
                (click)="displayUniLookupModal()"
                (focus)="displayUniLookupModal()"
              />
              <div class="spinner uni" *ngIf="loadingUni()"></div>
              <a
                class="lookup-list-link"
                id="uni-lll"
                *ngIf="!loadingUni()"
                (click)="displayUniListModal($event)"
                [class.grayout]="isUnihomeDeeplink()"
              >
                List
              </a>
            </div>
            <span
              class="error"
              *ngIf="
                (submitted() || formControl['university_name'].dirty) &&
                formControl['university_id'].errors &&
                formControl['university_id'].errors['required']
              "
            >
              {{ pageData.university_name_error }}
            </span>
          </div>
        </div>

        <!-- University modals -->
        <app-modal
          [show]="showTooltipModal()"
          (showChange)="showTooltipModal.set($event)"
          [showBuddy]="false"
        >
          <app-tooltip-modal
            [content]="tooltipModalContent()"
          ></app-tooltip-modal>
        </app-modal>

        <app-modal
          [show]="showUniLookupModal()"
          (showChange)="showUniLookupModal.set($event)"
          [showBuddy]="true"
          [uniListModal]="true"
          #uniLookupModal
        >
          <h4 class="modal-title">{{ pageData.university_name }}</h4>
          <app-uni-lookup
            (closeSelf)="hideUniSelectionModals()"
            (uniSelected)="universitySelected($event)"
            (addUni)="changeShowAddUniModal($event)"
            (alternativeUni)="handleNotAtUni()"
            [noUnisFoundMessage]="pageData.no_unis_found_message"
            [searchTerm]="uniLookupSearchTerm()"
            #uniLookup
          ></app-uni-lookup>
        </app-modal>

        <app-modal
          [show]="showUniListModal()"
          (showChange)="showUniListModal.set($event)"
          [showBuddy]="true"
          [uniListModal]="true"
          #uniListModal
        >
          <h4 class="modal-title">
            {{ pageData.university_list_modal_title }}
          </h4>
          <app-uni-list
            (uniSelected)="universitySelected($event)"
            (addUni)="changeShowAddUniModal($event)"
            (alternativeUni)="handleNotAtUni()"
            [noUnisFoundForLetterMessage]="
              pageData.no_unis_found_with_that_letter_message
            "
          ></app-uni-list>
        </app-modal>

        <app-modal
          [show]="showUniAddModal()"
          (showChange)="showUniAddModal.set($event)"
          [showBuddy]="true"
          #uniAddModal
        >
          <h4 class="modal-title">
            {{ pageData.university_list_modal_title }}
          </h4>
          <app-uni-add
            (uniAdded)="universityEntered($event)"
            [prefill]="addUniPrefill()"
            #uniAdd
          ></app-uni-add>
        </app-modal>

        <input
          type="hidden"
          name="residence_id"
          id="residence_id"
          formControlName="residence_id"
        />

        <!--
        Accommodation input
       -->
        <div class="form-row" *ngIf="!isUnihomeDeeplink()">
          <div class="form-field">
            <div class="label-container">
              <label for="residence_name">{{
                accommodationStayingText() ?? ''
              }}</label>
              <app-tooltip
                *ngIf="pageData.staying_tooltip && !isPPSelected()"
                [id]="accommodationInputTooltipId()"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>
            <p *ngIf="pageData.staying_info_copy">
              {{ pageData.staying_info_copy }}
            </p>
            <!-- setting autocomplete value stops field autocompleting -->
            <div class="lookup-wrapper">
              <input
                class="modal-lookup"
                formControlName="residence_name"
                type="text"
                name="residence_name"
                id="residence_name"
                autocomplete="residence_name"
                [class.error]="
                  (submitted() || formControl['residence_name'].dirty) &&
                  formControl['residence_id'].errors
                "
                (click)="displayResidenceLookupModal()"
                (focus)="displayResidenceLookupModal()"
              />
              <div
                class="spinner accommodation"
                *ngIf="loadingAccommodation()"
              ></div>
              <a
                href="#"
                class="lookup-list-link"
                id="residence-lll"
                *ngIf="!loadingAccommodation()"
                (click)="displayResidenceListModal($event)"
                >List</a
              >
            </div>
            <span
              class="error"
              *ngIf="
                (submitted() || formControl['residence_name'].dirty) &&
                formControl['residence_id'].errors &&
                formControl['residence_id'].errors['required']
              "
            >
              {{ pageData.staying_error }}
            </span>
          </div>
        </div>

        <!-- Accommodation lookup modal -->
        <app-modal
          [show]="showResidenceLookupModal()"
          (showChange)="showResidenceLookupModal.set($event)"
          [showBuddy]="true"
          [uniListModal]="true"
          #residenceLookupModal
        >
          <h4 class="modal-title">{{ accommodationStayingText() }}</h4>
          <p>{{ pageData.staying_info_copy }}</p>
          <app-residence-lookup
            (closeSelf)="hideResidenceSelectionModals()"
            (residenceSelected)="residenceSelected($event)"
            (alternateResidence)="handleAlternateResidence($event)"
            [noResidencesFoundMessage]="
              pageData.no_accommodations_found_message
            "
            [searchTerm]="residenceLookupSearchTerm()"
            #residenceLookup
          ></app-residence-lookup>
        </app-modal>

        <!-- Accommodation list modal -->
        <app-modal
          [show]="showResidenceListModal()"
          (showChange)="showResidenceListModal.set($event)"
          [showBuddy]="true"
          #residenceListModal
        >
          <h4 class="modal-title">{{ accommodationStayingText() }}</h4>
          <p>{{ pageData.staying_info_copy }}</p>
          <app-residence-list
            (residenceSelected)="residenceSelected($event)"
            (alternateResidence)="handleAlternateResidence($event)"
            [noResidencesFoundForLetterMessage]="
              pageData.no_accommodations_found_with_that_letter_message
            "
          ></app-residence-list>
        </app-modal>

        <!-- Account already exists modal -->
        <app-modal
          [show]="showUserUpdateChoice()"
          (showChange)="showUserUpdateChoice.set($event)"
        >
          <app-user-update-choice
            (updateDetails)="handleExistingAccountChoice($event)"
          ></app-user-update-choice>
        </app-modal>

        <!-- Login modal -->
        <app-modal
          [show]="showLoginModal()"
          (showChange)="showLoginModal.set($event)"
        >
          <app-login-modal
            [updateExistingAccountData]="getDetailsToUpdate"
          ></app-login-modal>
        </app-modal>

        <div class="form-row" *ngIf="isUnihomeDeeplink()">
          <div class="form-field">
            <div class="label-container">
              <label for="postcode">{{
                pageData.postcode_name ??
                  'Enter postcode of where you are staying'
              }}</label>
              <app-tooltip
                *ngIf="pageData.postcode_name_tooltip"
                id="postcode_name_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>
            <!-- setting autocomplete value stops field autocompleting -->
            <input
              class="modal-lookup postcode-width"
              formControlName="postcode"
              type="text"
              name="postcode"
              id="postcode"
              autocomplete="postcode"
              [class.error]="
                (submitted() || formControl['postcode'].dirty) &&
                formControl['postcode'].errors
              "
            />
            <span
              class="error"
              *ngIf="
                (submitted() || formControl['postcode'].dirty) &&
                formControl['postcode'].errors
              "
            >
              <ng-container
                *ngIf="
                  formControl['postcode'].errors['required'];
                  else postcodeInvalid
                "
              >
                {{ pageData.no_postcode_entered_error }}
              </ng-container>
              <ng-template #postcodeInvalid>
                {{ pageData.invalid_postcode_error }}
              </ng-template>
            </span>
          </div>
        </div>

        <div class="form-row">
          <div class="form-field">
            <div class="checkbox-row">
              <input
                formControlName="is_above_17"
                type="checkbox"
                name="is_above_17"
                id="is_above_17"
                value="1"
                [class.error]="submitted() && formControl['is_above_17'].errors"
              />
              <label for="is_above_17">
                {{ pageData.is_above_17_title }}
              </label>
            </div>
            <span
              class="error"
              *ngIf="submitted() && formControl['is_above_17'].errors"
            >
              {{ pageData.is_above_17_error }}
            </span>
          </div>
        </div>

        <ng-container *ngIf="mode() === 'email'">
          <div class="form-row no-flex-mobile">
            <div class="form-field">
              <div class="label-container">
                <label for="password">{{ pageData.password }}</label>
                <app-tooltip
                  *ngIf="pageData.password_tooltip"
                  id="password_tooltip"
                  (tooltipClicked)="openTooltip($event)"
                ></app-tooltip>
              </div>
              <input
                formControlName="password"
                type="password"
                name="password"
                id="password"
                [class.error]="
                  (submitted() || formControl['password'].dirty) &&
                  formControl['password'].errors
                "
              />
              <span
                class="error"
                *ngIf="
                  (submitted() || formControl['password'].dirty) &&
                  formControl['password'].errors
                "
              >
                <ng-container
                  *ngIf="
                    formControl['password'].errors['required'];
                    else passwordInvalid
                  "
                >
                  {{ pageData.password_empty_error }}
                </ng-container>
                <ng-template #passwordInvalid>
                  {{ pageData.password_invalid_error }}
                </ng-template>
              </span>
            </div>
            <div class="form-field">
              <div class="label-container">
                <label for="confirm_password">{{
                  pageData.confirm_password
                }}</label>
                <app-tooltip
                  *ngIf="pageData.confirm_password_tooltip"
                  id="confirm_password_tooltip"
                  (tooltipClicked)="openTooltip($event)"
                ></app-tooltip>
              </div>
              <input
                formControlName="confirm_password"
                type="password"
                name="confirm_password"
                id="confirm_password"
                [class.error]="
                  (submitted() || formControl['confirm_password'].dirty) &&
                  formControl['confirm_password'].errors
                "
              />
              <span
                class="error"
                *ngIf="
                  (submitted() || formControl['confirm_password'].dirty) &&
                  formControl['confirm_password'].errors
                "
              >
                <ng-container
                  *ngIf="
                    formControl['confirm_password'].errors['required'];
                    else confirmPasswordInvalid
                  "
                >
                  {{ pageData.confirm_password_empty_error }}
                </ng-container>
                <ng-template #confirmPasswordInvalid>
                  {{ pageData.confirm_password_match_error }}
                </ng-template>
              </span>
            </div>
          </div>
        </ng-container>

        <div class="form-row">
          <div class="form-field small-margin">
            <div class="checkbox-row">
              <input
                formControlName="accept_tc"
                type="checkbox"
                name="accept_tc"
                id="accept_tc"
                value="1"
                [class.error]="submitted() && formControl['accept_tc'].errors"
                (click)="tcBoxClicked($event)"
              />
              <label
                for="accept_tc"
                class="checkbox-label"
                (click)="toggleTsAndCs($event)"
              >
                {{ pageData.t_c }}
              </label>
            </div>
            <span
              class="error"
              *ngIf="submitted() && formControl['accept_tc'].errors"
            >
              {{ pageData.t_c_error }}
            </span>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field">
            <div class="checkbox-row">
              <input
                formControlName="accept_pc"
                type="checkbox"
                name="accept_pc"
                id="accept_pc"
                value="1"
                [class.error]="submitted() && formControl['accept_pc'].errors"
              />
              <label for="accept_pc" class="privacy-policy">
                {{ pageData.p_c }} the
                <span class="clickable" (click)="togglePsAndCs($event)"
                  >privacy policy</span
                >
                and the
                <a
                  *ngIf="pageData.cookie_policy_link"
                  [href]="pageData.cookie_policy_link"
                  [target]="pageData.cookie_policy_link"
                  >cookie policy</a
                >
              </label>
            </div>
            <span
              class="error"
              *ngIf="submitted() && formControl['accept_pc'].errors"
            >
              {{ pageData.p_c_error }}
            </span>
          </div>
        </div>

        <app-error-block *ngIf="registrationError()">
          {{ pageData.registration_error_message }} <br />
          <ng-container *ngIf="registrationErrorMessage(); else noErrorMessage">
            {{ registrationErrorMessage() }}
          </ng-container>
          <ng-template #noErrorMessage>
            There was an unknown error when trying to complete your
            registration.
          </ng-template>
        </app-error-block>

        <button
          class="button register-button"
          [class.button-loading]="registering()"
          type="submit"
          form="register-form"
        >
          {{ pageData.button_text }}
        </button>
      </form>
    </div>

    <div class="cover-container" *ngIf="pageData?.cover_image">
      <img
        [src]="pageData.cover_image.data.attributes.url"
        alt="Registration Cover Image"
      />
    </div>
  </div>

  <app-reg-modal
    [type]="'tc'"
    [show]="showTC()"
    (showChange)="showTC.set($event)"
    (acceptedChange)="tcAccepted($event)"
  ></app-reg-modal>
  <app-reg-modal
    [type]="'pc'"
    [show]="showPC()"
    (showChange)="showPC.set($event)"
    (acceptedChange)="pcAccepted($event)"
  ></app-reg-modal>
</section>
